export const TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE'

export const toggleLanguage = () => {
  return {
    type: TOGGLE_LANGUAGE
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/languageActions.js